import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import FeaturedSlider from "../components/FeaturedSlider";
import TrendingSection from "../components/TrendingSection";
import Sidebar from "../components/Sidebar";
import LatestArticlesSidebar from "../components/LatestArticlesSidebar";
import SEO from "../seo";
import API from "../api/api";
import YouTubeVerticalAd from "../components/YouTubeVerticalAd";

export default function HomePage() {
    const location = useLocation();
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        API.get("/api/articles/homepage")
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];

                const grouped = {};
                data.forEach((article) => {
                    if (!grouped[article.category]) {
                        grouped[article.category] = [];
                    }
                    grouped[article.category].push(article);
                });

                const formatted = Object.keys(grouped).map((category) => {
                    const articles = grouped[category];
                    return {
                        category,
                        latestDate: articles[0]?.created_at,
                        articles: articles.slice(0, 4),
                    };
                });

                formatted.sort(
                    (a, b) => new Date(b.latestDate) - new Date(a.latestDate)
                );

                setSections(formatted);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [location.pathname]);

    if (loading) {
        return <div className="py-20 text-center">Loading homepage…</div>;
    }

    return (
        <>
            {/* ================= HOME PAGE SEO ================= */}
            <SEO
                title="Latest Sports News, Live Scores & Match Updates"
                description="BlogySports brings you the latest sports news, live scores, match previews, predictions, and expert analysis from cricket, football, basketball, and more."
                canonical="https://blogysports.com/"
                image="https://blogysports.com/logo-blogysports.png"
            />
            <div className="max-w-7xl mx-auto px-6 pt-6 pb-4">

                {/* ✅ SEO H1 (hidden visually, safe for Google) */}
                <h1 className="sr-only">
                    Latest Sports News, Live Scores & Match Analysis
                </h1>

                {/* ✅ Optional intro text (hidden for clean UI) */}
                <p className="sr-only">
                    Get the latest sports news, live match updates, expert analysis, and
                    in-depth coverage of cricket, football, and other major sports on BlogySport.
                </p>

            </div>

            {/* FEATURED SLIDER */}
            <FeaturedSlider />

            {/* MAIN LAYOUT */}
            <div className="px-4 sm:px-6 mt-8 grid grid-cols-1 lg:grid-cols-4 gap-8">

                {/* MAIN CONTENT */}
                <div className="lg:col-span-3 space-y-16">
                    {sections.map((section) => (
                        <TrendingSection
                            key={section.category}
                            title={section.category}
                            posts={section.articles}
                        />
                    ))}
                </div>

                {/* SIDEBAR */}
                <div className="lg:col-span-1 space-y-8">
                    <Sidebar />
                    <LatestArticlesSidebar />
                    <div>
                        <YouTubeVerticalAd />
                    </div>
                </div>
            </div>
        </>
    );
}
